import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from './style/gstheme';

const styles = Object.assign({
}, globalStyles);

class OrderedUnordered extends React.Component {

    render() {

        const { classes, orderType, onChange } = this.props;

        return (
            <FormControl component="fieldset" style={{ marginBottom: '8px' }}>
                <legend className={classes.hideLegend}>Type of Collection</legend>
                <RadioGroup row aria-label="Select ordered or unordered" name="orderType" value={orderType} onChange={onChange}>
                    <FormControlLabel data-test="ordered" value="Ordered" control={<Radio color="primary" />} label="Ordered"
                        classes={{ label: classes.formLabelInline }}
                    />
                    <FormControlLabel data-test="unordered" value="Unordered" control={<Radio color="primary" />} label="Unordered"
                        classes={{ label: classes.formLabelInline }}
                    />
                </RadioGroup>
            </FormControl>
        );
    }
}

OrderedUnordered.propTypes = {
    orderType: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(OrderedUnordered);